import type { ReactNode } from 'react';
import { Route } from 'react-router-dom';

import { OnboardingCompletionGuard } from '@/app/router/OnboardingCompletionGuard';
import { ProtectedRoute } from '@/app/router/ProtectedRoute';

import { SessionFillScreen } from './pages/SessionFillScreen';
import { SessionReviewScreen } from './pages/SessionReviewScreen';
import { SessionsListScreen } from './pages/SessionsListScreen';
import { SessionViewScreen } from './pages/SessionViewScreen';

const guarded = (element: ReactNode) => (
  <ProtectedRoute>
    <OnboardingCompletionGuard>{element}</OnboardingCompletionGuard>
  </ProtectedRoute>
);

export const sessionsRoutes = (
  <>
    <Route path="/sessions" element={guarded(<SessionsListScreen />)} />
    {/* View — read-only, no actions */}
    <Route path="/sessions/:sessionId" element={guarded(<SessionViewScreen />)} />
    {/* Review — reviewer approves / rejects / holds (actions added here later) */}
    <Route path="/sessions/:sessionId/review" element={guarded(<SessionReviewScreen />)} />
    {/* Fill — session start and resume, minimal shell */}
    <Route path="/sessions/:sessionId/fill" element={guarded(<SessionFillScreen />)} />
  </>
);
